import { RecordStatus } from '../../types/menu/enums.types';
import { PermissionLevel, UserPermissionType } from '../../types/public/enum.types';

const moduleId = 29;
const featureId = 150;
const appId = 1;
export const momRecipePermissions = {
  'recipes-visible': {
    permissionId: 5,
    appId,
    moduleId,
    featureId,
    key: 'recipes-visible',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-create': {
    permissionId: 1,
    appId,
    moduleId,
    featureId,
    key: 'recipes-create',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-read': {
    permissionId: 4,
    appId,
    moduleId,
    featureId,
    key: 'recipes-read',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-edit': {
    permissionId: 2,
    appId,
    moduleId,
    featureId,
    key: 'recipes-edit',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
  'recipes-delete': {
    permissionId: 3,
    appId,
    moduleId,
    featureId,
    key: 'recipes-delete',
    isGranted: true,
    isApprovalNeeded: false,
    permissionLevel: PermissionLevel.FEATURE,
    type: UserPermissionType.ROLE,
    status: RecordStatus.ACTIVE,
    createdBy: 'System',
  },
};

export const defaultMomRecipePermissionsPermissions = [
  momRecipePermissions['recipes-visible'],
  momRecipePermissions['recipes-create'],
  momRecipePermissions['recipes-edit'],
  momRecipePermissions['recipes-read'],
  momRecipePermissions['recipes-delete'],
];
